export default __webpack_public_path__ + "f6d8b3c61edbbdfa20be536296745729.svg";